import {
    GET_TODO_VIEW_DATA_SUCCESS,
    TOGGLE_VIEW,
    SHOW_MORE_CALENDAR_VIEW,
    COMPLETE_DIARY_SUCCESS_VIEW,
    FETCH_DIARY_INFO_SUCCESS,
    GET_DIARY_LOGS_DAY_VIEW_SUCCESS,
    UPDATE_CAPTION_TODOVIEW_SUCCESS,
    RESET_DIARY_VIEW_DATA,
    RESET_DIARY_VIEW_DIARYINFO_DATA,
    CANCEL_DIARY_SUCCESS_VIEW,
    UPDATE_DIARY_VIEW_SUCCESS,
    UPDATE_TODO_MONTH_DATA,
    UPDATE_TODO_WEEK_DATA,
    CHANGE_VIEW_ACTIVE_TAB
} from '../actions/actionConstants';
import {mergeArrayByKey} from "../../../common/util";
import {getFileGalleryData} from "./listing";

const initialState = {
    data: [],
    view: "",
    endDate:"",
    startdate:"",
    diaryInfo: {
        detail: {},
        logs: {},
        galleryData:[],
        activeTab:0
    },
    showMore: {
        flag: false,
        timeKey: ''
    }

};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_TODO_VIEW_DATA_SUCCESS: {
            if(state.view=='list'){
                return Object.assign({}, state, { data: action.payload });
            }
            return Object.assign({}, state, { data: action.payload.data,startdate:action.payload.startdate,endDate:action.payload.endDate });
        }
        case TOGGLE_VIEW:
            return Object.assign({}, state, { view: action.payload.view });

        case SHOW_MORE_CALENDAR_VIEW:
            return Object.assign({}, state, { showMore: action.payload });

        case COMPLETE_DIARY_SUCCESS_VIEW:
            let newStatus = "",menuActions=[];
            if (action.payload.isComplete) {
                newStatus = 'COMPLETED';
                menuActions = ['3', '4']
            }
            else {
                newStatus = 'OPEN';
                menuActions = ['0', '1', '2', '4']
            }
            let updateKeyState=[];
            if(action.payload.key != "detail" && action.payload.key != "notification" && action.payload.key != 'views'){
                let filteredData = (state.view == "month") ? state.data[action.payload.key] : state.data[action.payload.key.split(",")[0]][action.payload.key.split(",")[1]];
                let changedData = filteredData.map(item => {
                    if (item.Id == action.payload.id) {
                        return Object.assign({}, item, { IsCompleted: action.payload.isComplete, Status: newStatus, menuActions: menuActions });
                    }
                    return item;
                });
                changedData = (state.view == "month") ? {[action.payload.key] : changedData}: { [action.payload.key.split(",")[1]]: changedData};
                if(state.view=="day"){
                    updateKeyState = Object.assign({}, state.data[action.payload.key.split(",")[0]], changedData);
                    updateKeyState=Object.assign({}, state.data,{[action.payload.key.split(",")[0]]:  updateKeyState})    
                }
                else{
                    updateKeyState = Object.assign({}, state.data,  changedData );
                }
            }
            let diaryInfoData = (Object.keys(state.diaryInfo.detail).length) ? Object.assign({},state.diaryInfo.detail,{Status:newStatus,IsCompleted:action.payload.isComplete, menuActions:menuActions, PreetyCompletedDate: action.payload.completedDate }):{};
            diaryInfoData=Object.assign({},state.diaryInfo,{detail:diaryInfoData});
            
            return Object.assign({}, state, { data: updateKeyState, diaryInfo: diaryInfoData });

        case FETCH_DIARY_INFO_SUCCESS:{
            let menu=[];
            if (action.payload.Status == 'COMPLETED') {
                menu = ['3', '4']
            }
            else {
                menu = ['0', '1', '2', '4']
            }
            let detail = Object.assign({}, action.payload, { menuActions: menu });
            const galleryData = getFileGalleryData(action.payload.fileData)
            detail = Object.assign({}, state.diaryInfo, { detail: detail,galleryData:[galleryData] });
            return Object.assign({}, state, { diaryInfo: detail });
        }
        case CHANGE_VIEW_ACTIVE_TAB:{
            const info = Object.assign({}, state.diaryInfo, {activeTab:action.payload.activeTab});
            return Object.assign({},state,{diaryInfo:info}); 
        }
        case GET_DIARY_LOGS_DAY_VIEW_SUCCESS:
            let creationLog = {
                OwnerView: {
                    DisplayName: action.payload.creatorName,
                    creatorProfileUrl: action.payload.creatorProfileUrl,
                    ProfileFullImage: action.payload.creatorProfileImage
                },
                NonFormatedUpdatedDate: action.payload.createdDate,
                Field: "CreationLog"
            };
            Object.keys(creationLog).forEach(e => delete action.payload[e]);
            let logs;
            if(action.payload.todoLogs){
                action.payload.todoLogs.push(creationLog);
                logs = Object.assign({}, state.diaryInfo, { logs: action.payload });
            }
            else{
                logs = Object.assign({}, state.diaryInfo, { logs: {todoLogs:[...creationLog] }});
            }
            return Object.assign({}, state, { diaryInfo: logs });
        case UPDATE_CAPTION_TODOVIEW_SUCCESS:{
            const fileData= state.diaryInfo.detail.fileData.Files.map(item=>{
                if(item.Id==action.payload.id){
                    return Object.assign({},item,{Caption:action.payload.caption})
                }
                return item;
            })
            const updateDetail = Object.assign({},state.diaryInfo.detail,{fileData:{Files: [...fileData]}});
            const updatedInfo= Object.assign({}, state.diaryInfo, {detail: updateDetail });
            return Object.assign({}, state, {diaryInfo: updatedInfo });
        }
        case RESET_DIARY_VIEW_DATA:
            return Object.assign({}, state, {data: [],
                view: state.view,
                diaryInfo: {
                    detail: {},
                    logs: {},
                    activeTab:0
                }});
        case RESET_DIARY_VIEW_DIARYINFO_DATA:
            return Object.assign({}, state, {diaryInfo:initialState.diaryInfo});
        case CANCEL_DIARY_SUCCESS_VIEW:
            let updateFilteredData = (state.view == "month") ? state.data[action.payload.key] : state.data[action.payload.key.split(",")[0]][action.payload.key.split(",")[1]];
            updateFilteredData = updateFilteredData.map(item => {
                if (item.Id == action.payload.id) {
                    return Object.assign({}, item, {Status:"CANCELLED", menuActions:[] });
                }
                return item;
            });
            updateFilteredData = (state.view == "month") ? {[action.payload.key] : updateFilteredData}: {[action.payload.key.split(",")[0]]: { [action.payload.key.split(",")[1]]: updateFilteredData}}
            updateFilteredData = Object.assign({}, state.data, updateFilteredData );

            return Object.assign({}, state, {data: updateFilteredData });

        case UPDATE_DIARY_VIEW_SUCCESS:{
            return Object.assign({}, state, { data: action.payload.data});
        }
        case UPDATE_TODO_MONTH_DATA:{
                let key = action.payload.date.split(',')[0].split('/')[1];
                const stateMonthData = state.data[key] ? state.data[key] :[]
                let changedData = mergeArrayByKey(stateMonthData,action.payload.data[key],'Id');
                changedData = {[key] : changedData};
                const updateKeyState = Object.assign({}, state.data,  changedData );
                return Object.assign({}, state, { data: updateKeyState});
        }
        case UPDATE_TODO_WEEK_DATA:{
            let key = action.payload.date.split(',')[0].split('/')[1] + ',' + action.payload.date.split(',')[1].split(':')[0] + action.payload.date.split(',')[1].split('00')[1];
            const stateWeekData =state.data[key.split(",")[0]] ? 
                (state.data[key.split(",")[0]][key.split(",")[1].replace(/^\s+/g, '')] ? state.data[key.split(",")[0]][key.split(",")[1].replace(/^\s+/g, '')]:[]):[];

            let changedData = mergeArrayByKey(stateWeekData ,action.payload.data[key.split(",")[0]][key.split(",")[1].replace(/^\s+/g, '')],'Id');

            changedData = {[key.split(",")[1].replace(/^\s+/g, '')]: changedData};

            changedData = Object.assign({}, state.data[key.split(",")[0]], changedData);
            changedData=Object.assign({}, state.data,{[key.split(",")[0]]:  changedData})  
            const updateKeyState = Object.assign({}, state.data,  changedData );
            return Object.assign({}, state, { data: updateKeyState});
        }
        default:
            return state;
    }
}
